export default "__VITE_ASSET__209ed56d__"